var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailMinidumpSwitchNormal = function SvgNewcsDashboardCrashanalysisIssuedetailMinidumpSwitchNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_minidump_switch_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M795 297h12v11h-12z",
    "data-name": "\\u77E9\\u5F62 368"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_minidump_switch_normal_svg__a)",
    transform: "translate(-795 -297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M806.433 301.508h-10.866a.6.6 0 0 1 0-1.2h9.5l-1.682-1.782a.626.626 0 0 1 0-.849.545.545 0 0 1 .8 0l2.65 2.807a.63.63 0 0 1 .123.655.57.57 0 0 1-.525.369m-10.866 1.985h10.866a.6.6 0 0 1 0 1.2h-9.5l1.682 1.782a.626.626 0 0 1 0 .849.545.545 0 0 1-.8 0l-2.65-2.808a.63.63 0 0 1-.123-.655.57.57 0 0 1 .525-.369Z",
    opacity: 0.6
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailMinidumpSwitchNormal;